import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { useAuth } from './hooks/useAuth';
import LoginForm from './components/LoginForm';
import HomePage from './components/HomePage';
import PDFPage from './components/PDFPage';
import EditPage from './components/EditPage';
import NewInvoice from './components/NewInvoice';
import GeneralReport from './components/GeneralReport';
import ByCodeReport from './components/ByCodeReport';
import ByTeamReport from './components/ByTeamReport';
import CoelbaReport from './components/CoelbaReport';
import PaidReport from './components/PaidReport';
import PaidSummaryReport from './components/PaidSummaryReport';
import FaturamentoRealReport from './components/FaturamentoRealReport';
import DailyReport from './components/DailyReport';
import MonthlyReport from './components/MonthlyReport';
import AdminPage from './components/AdminPage';
import ByTypeReport from './components/ByTypeReport';
import './App.css';

function App() {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="loading-container">
        <div className="loading-spinner"></div>
        <p>Carregando...</p>
      </div>
    );
  }

  const handleLoginSuccess = () => {
    // Authentication state will be handled by useAuth hook
  };

  return (
    <Router>
      <div className="App">
        <Routes>
          <Route 
            path="/login" 
            element={
              user ? <Navigate to="/" replace /> : <LoginForm onLoginSuccess={handleLoginSuccess} />
            } 
          />
          <Route 
            path="/pdf" 
            element={<PDFPage />} 
          />
          <Route 
            path="/edit" 
            element={<EditPage />} 
          />
          <Route 
            path="/new" 
            element={<NewInvoice />} 
          />
          <Route 
            path="/reports/general" 
            element={<GeneralReport />} 
          />
          <Route 
            path="/reports/by-code" 
            element={<ByCodeReport />} 
          />
          <Route 
            path="/reports/by-team" 
            element={<ByTeamReport />} 
          />
          <Route 
            path="/reports/coelba" 
            element={<CoelbaReport />} 
          />
          <Route 
            path="/reports/paid" 
            element={<PaidReport />} 
          />
          <Route 
            path="/reports/paid-summary" 
            element={<PaidSummaryReport />} 
          />
          <Route 
            path="/reports/daily" 
            element={<DailyReport />} 
          />
          <Route 
            path="/reports/monthly" 
            element={<MonthlyReport />} 
          />
          <Route 
            path="/reports/faturamento-real" 
            element={<FaturamentoRealReport />} 
          />
          <Route 
            path="/reports/by-type" 
            element={<ByTypeReport />} 
          />
          <Route 
            path="/admin" 
            element={<AdminPage />} 
          />
          <Route 
            path="/" 
            element={
              user ? <HomePage /> : <Navigate to="/login" replace />
            } 
          />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
